__turbopack_context__.v({
  "className": "QmNl4G_className",
  "variable": "QmNl4G_variable",
});
